import type { SVGProps } from "react";

const Mcp = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 180 180" fill="none" aria-hidden="true" {...props}>
    <path
      d="M18 84.853 85.882 16.97c9.373-9.372 24.569-9.372 33.941 0 9.373 9.373 9.373 24.569 0 33.942L68.558 102.177"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
    />
    <path
      d="m69.265 101.47 50.558-50.558c9.373-9.373 24.569-9.373 33.942 0l.353.353c9.373 9.373 9.373 24.569 0 33.941L92.725 146.6a8 8 0 0 0 0 11.313l12.606 12.607"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
    />
    <path
      d="M102.853 33.941 52.648 84.146c-9.372 9.372-9.372 24.568 0 33.941 9.373 9.372 24.569 9.372 33.941 0l50.205-50.205"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
    />
  </svg>
);

export default Mcp;
